<div class="flex flex-row items-center">
  <div [className]="imageClass"></div>
</div>
